import React from 'react'

const ConfirmRelation = () => {
  return (
    <div>
    </div>
  )
}

export default ConfirmRelation



// WEBPACK FOOTER //
// ./src/App/component/ConfirmRelation/index.jsx